module.exports = __webpack_public_path__ + "img/kczx.ceaddcd7.png";